var _path, _rect, _mask, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaviconDarkMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M668.543 533.643C703.896 567.599 682.993 633.224 682.993 633.224H365.079C365.079 633.224 357.629 632.71 352.852 629.194C347.699 625.403 345.626 617.107 345.626 617.107L334.51 500.258C334.51 500.258 331.802 481.842 337.289 477.809C341.184 474.947 350.072 476.082 350.072 476.082H477.905C477.905 476.082 482.356 476.004 484.575 477.809C486.256 479.176 487.354 484.716 487.354 484.716L505.139 617.107H529.038L512.365 503.136C512.365 503.136 619.985 487.006 668.543 533.643Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 519.533,
    y: 356.28,
    width: 113.494,
    height: 119.878,
    rx: 56.7468,
    fill: "white",
    stroke: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_117_27",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262 495.5C262 357.705 373.705 246 511.5 246C649.295 246 761 357.705 761 495.5C761 633.295 649.295 745 511.5 745C373.705 745 262 633.295 262 495.5Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M253 491C253 350.72 366.72 237 507 237H516C656.28 237 770 350.72 770 491L752 495.5C752 362.675 644.325 255 511.5 255H511.5C378.675 255 271 362.675 271 495.5L253 491ZM271 495.5M761 745H262H761M507 745C366.72 745 253 631.28 253 491C253 350.72 366.72 237 507 237L511.5 255C378.675 255 271 362.675 271 495.5C271 633.295 378.675 745 511.5 745H507ZM516 237C656.28 237 770 350.72 770 491C770 631.28 656.28 745 516 745H511.5C644.325 745 752 633.295 752 495.5C752 362.675 644.325 255 511.5 255L516 237Z",
    fill: "white",
    mask: "url(#path-3-inside-1_117_27)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M582.653 767.192L565.416 700.888L521.492 744.252L582.653 767.192Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaviconDarkMode);
export default __webpack_public_path__ + "static/media/favicon-dark-mode.8c763c3b17d63f72737ad21339e4abd7.svg";
export { ForwardRef as ReactComponent };